import { Instagram, Linkedin, Youtube, Twitter } from "lucide-react";
import { CONTACT } from "../data/content";

const QUICK = [
  { label: "Services", href: "#services" },
  { label: "Case Studies", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-[#0A0C0E]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <a href="#top" data-testid="footer-logo" className="font-heading leading-none inline-block mb-5">
          <span className="block text-white font-extrabold text-xl tracking-tight">branded</span>
          <span className="block text-[#A3E635] font-extrabold text-xl tracking-tight -mt-1">by knowfinity</span>
        </a>
        <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
          Turning digital attention into measurable business growth. Bengaluru, Karnataka, India.
        </p>
      </div>

      <div>
        <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-slate-500 mb-5">Explore</p>
        <div className="flex flex-col gap-3">
          {QUICK.map((q) => (
            <a key={q.href} href={q.href} data-testid={`footer-link-${q.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-slate-400 hover:text-[#A3E635] transition-colors duration-300 w-fit">
              {q.label}
            </a>
          ))}
        </div>
      </div>

      <div>
        <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-slate-500 mb-5">Connect</p>
        <div className="flex gap-3">
          {[
            { Icon: Instagram, href: CONTACT.instagram, id: "instagram" },
            { Icon: Linkedin, href: CONTACT.instagram, id: "linkedin" },
            { Icon: Youtube, href: CONTACT.instagram, id: "youtube" },
            { Icon: Twitter, href: CONTACT.instagram, id: "twitter" },
          ].map(({ Icon, href, id }) => (
            <a
              key={id}
              href={href}
              target="_blank"
              rel="noreferrer"
              data-testid={`footer-social-${id}`}
              className="h-10 w-10 rounded-full border border-white/10 bg-black/50 flex items-center justify-center text-slate-400 hover:text-[#A3E635] hover:border-[#A3E635]/50 transition-all duration-300"
            >
              <Icon size={16} />
            </a>
          ))}
        </div>
        <p className="text-sm text-slate-500 mt-5">{CONTACT.email}</p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-slate-600">
          © 2026 Branded by Knowfinity. All rights reserved.
        </p>
        <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-slate-600">
          Your brand. <span className="text-[#A3E635]">Amplified to infinity.</span>
        </p>
      </div>
    </div>
  </footer>
);
